import React, { useContext, useEffect, useState } from "react";
import OrgTabPageShell from "../OrgTabPageShell";
import { Card, Button, Input, Form, message } from "antd";
import styles from "../../../../styles/Custom/Dashboard/Dashboard.module.css";
import orgStyles from "../../orgSettings.module.css";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { UserContext } from "../../../../context/UserContext";
import { updateOrgDetailsApi } from "../../../../services/org.services";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";

const OrgContact = ({ data, refreshPage, sideContent }) => {
  const { userDetails } = useContext(UserContext);
  const [details, setDetails] = useState(false);
  const [form] = Form.useForm();
  const [changedFields, setChangedFields] = useState([]);

  const defaultRole = userDetails?.currRole || getCookie(Role);
  const isOrgAdminOrOwner =
    defaultRole === "Organization_Owner" ||
    defaultRole === "Organization_Admin";

  const onFinish = (values) => {
    updateOrgDetailsApi(values)
      .then(() => {
        refreshPage();
        changedFields.forEach((field) => {
          let label = "";
          if (field === "phone") label = "Contact Number";
          if (field === "email") label = "Email";
          if (field === "address") label = "Location";
          if (label) message.success(`The ${label} updated successfully`);
        });
        setChangedFields([]);
        setDetails(false);
      })
      .catch((err) => message.error(err?.response?.data?.message));
  };

  useEffect(() => {
    if (data) {
      form.resetFields();
      form.setFieldsValue(data);
    }
  }, [data]);

  const footer = details && (
    <div className="flex-end" style={{ gap: "24px" }}>
      <Button className={btnStyles.mdBtn} onClick={() => setDetails(false)}>
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={() => form.submit()}
        className={btnStyles.mdBtn}
      >
        Save
      </Button>
    </div>
  );

  return (
    <OrgTabPageShell sideContent={sideContent} footer={footer}>
      <Card
        className={`${styles.personalDetailsCard} ${orgStyles.orgProfileCard} centeredCard`}
      >
        <Form
          onFinish={onFinish}
          onFinishFailed={(values) => console.log(values)}
          onValuesChange={(changedValues) => {
            setDetails(true);
            const fieldName = Object.keys(changedValues)[0];
            setChangedFields((prev) =>
              prev.includes(fieldName) ? prev : [...prev, fieldName]
            );
          }}
          className={orgStyles.orgForm}
          layout="vertical"
          form={form}
        >
          <Form.Item name="address" label="Location">
            <Input
              disabled={!isOrgAdminOrOwner}
              placeholder="Enter location"
              style={{ width: "100%" }}
              className={inputStyles.mdInput}
            />
          </Form.Item>
          <Form.Item name="email" label="Email">
            <Input
              disabled={!isOrgAdminOrOwner}
              placeholder="Enter email"
              style={{ width: "100%" }}
              className={inputStyles.mdInput}
            />
          </Form.Item>
          <Form.Item
            name="phone"
            label="Contact number"
            rules={[
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit phone number",
              },
            ]}
          >
            <Input
              disabled={!isOrgAdminOrOwner}
              maxLength="10"
              addonBefore={"+91"}
              placeholder="Enter contact number"
              style={{ width: "100%" }}
              className={inputStyles.mdAddonInput}
            />
          </Form.Item>
        </Form>
      </Card>
    </OrgTabPageShell>
  );
};

export default OrgContact;
